import { PeriodColumnParams } from '@core/typings/period-column-params';
import { PlanningBoardPeriodService } from '@services/planning-board-period.service';
import { AssignmentRow } from '@shared/components/grids/rows/assignments/assignment-row';
import { CellPosition, ColDef, Column, HeaderPosition } from 'ag-grid-community';

export class GridNavigationHelper {
  private static getPeriodIndexByCellPos(cellPosition: CellPosition | HeaderPosition) {
    let periodIndex: number | undefined;
    if (this.isColumn(cellPosition?.column)) {
      const coldef: ColDef<AssignmentRow> | undefined = cellPosition?.column.getColDef();
      const periodColumnParams = coldef?.cellRendererParams as PeriodColumnParams | undefined;
      periodIndex = periodColumnParams?.periodIndex;
    }
    return periodIndex;
  }

  public static MoveCellPosition<T extends CellPosition | HeaderPosition>(
    planningBoardPeriodService: PlanningBoardPeriodService,
    previousPosition: T | null,
    nextPosition: T | null
  ) {
    const previousCellPeriodIndex = previousPosition ? this.getPeriodIndexByCellPos(previousPosition) : undefined;
    const nextCellPeriodIndex = nextPosition ? this.getPeriodIndexByCellPos(nextPosition) : undefined;

    if (
      previousCellPeriodIndex == undefined ||
      (nextCellPeriodIndex != undefined && previousCellPeriodIndex != undefined)
    ) {
      return nextPosition;
    }

    const isGoingBackward = previousCellPeriodIndex === 0;
    void planningBoardPeriodService.navigateBy(isGoingBackward ? -1 : 1);
    return previousPosition;
  }

  private static isColumn(obj: unknown): obj is Column {
    return (
      typeof obj === 'object' && obj !== null && 'getColDef' in obj && typeof (obj as Column).getColDef === 'function'
    );
  }
}
